// extracted by mini-css-extract-plugin
export default {"paginationContainer":"Pagination_paginationContainer__WFAJS","prev":"Pagination_prev__Vc3vi","next":"Pagination_next__1xfHq"};